import { atom, selector } from "recoil";

export const drawCoastLineOverContentsState = atom({
  key: 'drawCoastLineOverContentsState',
  default: []
});

export const addDrawCoastLineOverContentsState = selector({
  key: 'addDrawCoastLineOverContentsState',
  set: ({get, set}, contentsId) => {
    const oldList = get(drawCoastLineOverContentsState);
    const idx = oldList.indexOf(contentsId);
    if (idx !== -1) return;

    const newList = [...oldList, contentsId];
    set(drawCoastLineOverContentsState, newList);
  },
  get: () => {}
});

export const removeDrawCoastLineOverContentsState = selector({
  key: 'removeDrawCoastLineOverContentsState',
  set: ({get, set}, contentsId) => {
    const oldList = get(drawCoastLineOverContentsState);
    const idx = oldList.indexOf(contentsId);
    if (idx === -1) return;

    const newList = [...oldList.slice(0, idx), ...oldList.slice(idx + 1)];
    set(drawCoastLineOverContentsState, newList);
  },
  get: () => {}
});
